import React from 'react';
import {
    List,
} from 'reactstrap';
import { debounce } from 'lodash-es';
import AsyncSelect from 'react-select/async';
import { httpClient } from '@s20/services/httpClient';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import {
    AppPageForm, onFieldChange, toasty,
} from '../common/forms/FormElements';
import CustomCircularProgress from '../common/CustomCircularProgress';
import { Block, BlockBorder } from '../common/Block';
import { SaveButton } from '../common/forms/SaveButton';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { ExecutionHistory } from './common/ExecutionHistory';

class ExportEmployeeTimesheetsViewModel {
    employeeId = null;
}

class ExportEmployeeTimesheets extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            formValidated: false,
            loading: false,
            saving: false,
            data: new ExportEmployeeTimesheetsViewModel(),
            isValidated: false,
        };
    }

    onEmployeeChanged = (selection) => {
        this.setState((state) => ({
            data: {
                ...state.data,
                employee: selection,
                employeeId: selection?.value ?? null,
            },
        }));
    };

    loadEmployeeOptions = debounce((inputValue, callback) => {
        if (!inputValue || inputValue.length < 2) {
            callback([]);
            return;
        }

        httpClient.js(ApiRoutes.typeAheads.searchEmployees(inputValue, true))
            .then((data) => {
                callback(data);
            })
            .catch(() => {
                callback([]);
            });
    }, 300);

    onChange = onFieldChange;

    onSubmit = async () => {
        const { data } = this.state;

        this.setState({ saving: true });

        try {
            await httpClient.downloadServerFile(
                ApiRoutes.adminTool.exportEmployeeTimesheets(),
                data,
            );

            this.setState({
                data: new ExportEmployeeTimesheetsViewModel(),
                isValidated: false,
            });

            // Refresh the table after successful submission
            await this.props.refreshUsageHistory();
        } catch (err) {
            console.error(err);
            toasty.error(
                'Error: Could not export timesheets. Please Check Form Inputs',
            );
            await this.props.refreshUsageHistory();
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        const {
            loading,
            saving,
            isValidated,
            data,
        } = this.state;

        if (loading) {
            return (
                <div className="confirmationContainer pt-2 d-flex flex-row align-items-center justify-content-center">
                    <CustomCircularProgress
                        color="secondary"
                        variant="indeterminate"
                        label={
                            this.props.match.params.id
                                ? 'Getting Tool History...'
                                : 'Loading form...'
                        }
                    />
                </div>
            );
        }

        if (!(this.context ?? {}).user) return null;

        return (
            <AppPageForm
                backUrl={AppNavPaths.AdminTool}
                backLabel="Back to Admin Tools"
                formShown={this.context.formIsOpen}
                formId="adminToolList"
                formName="adminToolList"
                formHeading="Export Employee Timesheets"
                formRef={this.formRef}
                formIsColumn
                saving={saving}
                isValidated={isValidated}
                onSubmit={this.onSubmit}
                setIsValidated={(value) => {
                    this.setState({ isValidated: value });
                }}
            >
                <Block padding="medium">
                    <div>
                        <ValidatedSelect
                            component={AsyncSelect}
                            id="employeeId"
                            name="employeeId"
                            label="Employee"
                            required
                            loadOptions={this.loadEmployeeOptions}
                            placeholder="Type to search employees..."
                            onChange={this.onEmployeeChanged}
                            value={data.employee}
                            isClearable
                            cacheOptions
                            error="An employee selection is required."
                        />

                        <BlockBorder />

                        <div className="d-flex justify-content-center">
                            <SaveButton
                                saving={saving}
                                label="Submit"
                            />
                        </div>
                    </div>
                </Block>

                <ExecutionHistory usageHistory={this.props.usageHistory}>
                    {(record) => (
                        <List type="unstyled">
                            {record.input.employeeName && (
                                <li>
                                    <strong>Employee name:</strong>
                                    {' '}
                                    {record.input.employeeName}
                                </li>
                            )}
                        </List>
                    )}
                </ExecutionHistory>
            </AppPageForm>
        );
    }
}

export default ExportEmployeeTimesheets;
